module.exports = __webpack_public_path__ + "img/11_99.7b72c493.png";